<template>
    <main class="single-page">
        <div class="col-2">
            <h1>{{this.$parent.page.title}}</h1>
            <div>
                <img v-if="this.$parent.page.ckc_cover_image" :src="this.$parent.page.ckc_cover_image" alt="" />
                <img v-else src="~@/assets/img/default.png" alt="" />
            </div>
            <div class="text-up" style="margin-bottom: 30px">
                <div v-html="this.$parent.page.text"></div>
                <div class="icon-links to-right">
                    <a v-if="null" :href="this.$parent.fbShareURL"><i class="icon-fb"></i></a>
                </div>
            </div>
        </div>
    </main>
</template>

<script>


// components

import PageRelated from '@/components/Page/PageRelated.vue'

// functions
// img przepisac z @load

export default {
    name: 'PageContent',
    components: {
        PageRelated
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },
    methods: {
    },
    destroyed() {
    },
    mounted: function() {
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Page/PageContent.vue